export const handleChangeDataMembershipEliteDoctorsPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_MEMBERSHIP_ELITE_DOCTORS', name, value
});